import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      const next = params.get("next") || "/dashboard";
      nav(next);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="pt-32 pb-24 min-h-screen fade-in">
      <div className="max-w-md mx-auto px-6">
        <h1 className="font-serif text-5xl text-stone-900">Welcome back.</h1>
        <p className="mt-2 text-stone-600">Sign in to manage your bookings & tutorials.</p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="text-xs tracking-[0.2em] uppercase text-stone-500 block mb-2">Email</label>
            <input
              data-testid="login-email"
              type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border-2 border-[#121212] focus:border-[#121212] focus:outline-none focus:ring-2 focus:ring-[#121212]/20"
            />
          </div>
          <div>
            <label className="text-xs tracking-[0.2em] uppercase text-stone-500 block mb-2">Password</label>
            <input
              data-testid="login-password"
              type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border-2 border-[#121212] focus:border-[#121212] focus:outline-none focus:ring-2 focus:ring-[#121212]/20"
            />
          </div>
          <button
            data-testid="login-submit"
            disabled={busy}
            className="w-full px-6 py-4 bg-[#121212] text-[#F2E9D8] hover:bg-black text-xs tracking-[0.25em] uppercase font-bold disabled:opacity-40 transition-all"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-4 text-sm text-center">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-stone-600 hover:text-[#121212] hover:underline">Forgot your password?</Link>
        </p>
        <p className="mt-2 text-sm text-stone-600 text-center">
          New here? <Link to="/register" className="text-[#121212] hover:underline">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
